export default __webpack_public_path__ + "6b7b5d492d439fa85f8cd04270322024.png";